// سدر الخليج: القياس (STR-89، المرحلة 2، docs/studies/tracking-plan.md)
//
// window.sedrTrack(name, data): ينشر sedr_<name> في Shopify فيحمله البكسل sedr-analytics إلى GA4،
// ويرسل <name> حدثًا إلى Clarity. البيانات قيم محددة (مكان، نتيجة، ترتيب)، ولا يُرسل اسم ولا بريد ولا جوال
// ولا نص ملاحظة ولا رمز خصم (القسم 4 من الخطة).
// وسوم الجلسة في Clarity (القسم 5)، وأحداث السلة والوضع والبحث والمجموعات (6.2–6.4) بمستمعين على المستند
// وأحداث Impact، فلا يُعدَّل ملف من ملفات القالب، ولا يضيع شيء حين يُعاد رسم الدرج أو الأقسام.
// قيم Liquid في #sedr-track-config من snippets/sedr-track.liquid.

(() => {
  if (window.sedrTrack) return;

  let config = {};
  try { config = JSON.parse(document.getElementById('sedr-track-config').textContent); } catch (e) {}

  // Clarity يُحمَّل من تطبيقه، وهذا طابوره المعتاد يحفظ ما يُرسل قبله
  window.clarity = window.clarity || function () { (window.clarity.q = window.clarity.q || []).push(arguments); };

  const track = (window.sedrTrack = (name, data = {}) => {
    try { window.Shopify?.analytics?.publish?.(`sedr_${name}`, data); } catch (e) {}
    try { window.clarity('event', name); } catch (e) {}
  });
  const tag = (key, value) => {
    try { window.clarity('set', key, value); } catch (e) {}
  };

  // أحداث تسبق انتقالًا أو إعادة تحميل تُحفظ وتُرسل في الصفحة التالية، لأن البكسل قد يُغلق قبل أن يرسلها
  const PENDING = 'sedr:track:pending';
  const FREE_SENT = 'sedr:track:free';
  const later = (name, data) => {
    try {
      const list = JSON.parse(sessionStorage.getItem(PENDING)) || [];
      list.push([name, data]);
      sessionStorage.setItem(PENDING, JSON.stringify(list.slice(-5)));
    } catch (e) {
      track(name, data);
    }
  };
  try {
    const list = JSON.parse(sessionStorage.getItem(PENDING));
    sessionStorage.removeItem(PENDING);
    if (Array.isArray(list)) list.forEach((item) => Array.isArray(item) && track(item[0], item[1]));
  } catch (e) {}

  // نص البحث: 50 حرفًا، ويُحذف إن كان فيه بريد أو سبعة أرقام فأكثر بعد حذف الفواصل (جوال كُتب خطأً)
  const safeQuery = (value) => {
    const text = String(value || '').trim();
    if (!text || text.includes('@') || /\p{N}{7}/u.test(text.replace(/[^\p{L}\p{N}]/gu, ''))) return undefined;
    return text.slice(0, 50);
  };

  /* ------------------------------------------------------------ وسوم الجلسة */

  tag('lang', config.lang);
  tag('country', config.country);
  tag('customer', config.customer ? 'logged_in' : 'guest');

  const cartTag = (count) => tag('cart', count > 0 ? 'has_items' : 'empty');
  cartTag(config.cartCount);

  const root = document.documentElement;
  const mode = () => (root.getAttribute('data-scheme') === 'dark' ? 'dark' : 'light');
  tag('mode', mode());
  new MutationObserver(() => tag('mode', mode())).observe(root, { attributes: true, attributeFilter: ['data-scheme'] });

  const wishlistTag = (items) => tag('wishlist', Array.isArray(items) && items.length > 0 ? 'has_items' : 'empty');
  try { wishlistTag(JSON.parse(localStorage.getItem('sedr:wishlist'))); } catch (e) { wishlistTag(null); }
  document.addEventListener('sedr:wishlist:change', (event) => wishlistTag(event.detail?.items));

  /* ------------------------------------------------------------ السلة */

  // الشحن المجاني داخل المملكة: بحساب شريط Impact نفسه، ومرة في الجلسة حين يتجاوز المجموع الحد
  const freeThreshold = config.freeThreshold;
  let shipTotal = config.shipTotal;

  // لا تُحدَّث الوسوم أو أحداث الحد إلا ببيانات السلة التي نستخدمها، كاملة وصالحة.
  const cartState = (cart) => {
    const amount = (value) => Number.isSafeInteger(value) && value >= 0;
    if (!cart || typeof cart !== 'object' || Array.isArray(cart) || !amount(cart.item_count) || !Array.isArray(cart.items)) return null;
    if ((cart.item_count === 0) !== (cart.items.length === 0)) return null;
    const discounts = cart.cart_level_discount_applications ?? [];
    if (!Array.isArray(discounts)) return null;
    let items = 0;
    for (const item of cart.items) {
      if (!item || typeof item.requires_shipping !== 'boolean') return null;
      if (!item.requires_shipping) continue;
      if (!amount(item.final_line_price)) return null;
      items += item.final_line_price;
      if (!amount(items)) return null;
    }
    let discount = 0;
    for (const application of discounts) {
      if (!amount(application?.total_allocated_amount)) return null;
      discount += application.total_allocated_amount;
      if (!amount(discount)) return null;
    }
    return { count: cart.item_count, total: Math.max(0, items - discount) };
  };

  const checkFreeShipping = (total) => {
    if (!freeThreshold) return;
    const before = shipTotal;
    shipTotal = total;
    if (before >= freeThreshold || shipTotal < freeThreshold) return;
    try {
      if (sessionStorage.getItem(FREE_SENT)) return;
      sessionStorage.setItem(FREE_SENT, '1');
    } catch (e) {}
    track('free_shipping_reached', { subtotal: Math.round(shipTotal) / 100 });
  };

  const applyCart = (cart) => {
    const state = cartState(cart);
    if (!state) return false;
    cartTag(state.count);
    checkFreeShipping(state.total);
    return true;
  };

  let cartVersion = 0;
  let cartRequest = null;
  let refreshTimer = null;
  let refreshPending = false;
  const cancelRefresh = () => {
    clearTimeout(refreshTimer);
    refreshTimer = null;
    if (cartRequest) {
      clearTimeout(cartRequest.timer);
      cartRequest.controller.abort();
      cartRequest = null;
    }
  };

  const refreshCart = async (version) => {
    if (version !== cartVersion) return;
    const controller = new AbortController();
    const request = cartRequest = { controller, timer: null };
    let onAbort;
    const cancelled = new Promise((resolve, reject) => {
      onAbort = () => reject(new Error('cart refresh aborted'));
      controller.signal.addEventListener('abort', onAbort, { once: true });
    });
    request.timer = setTimeout(() => controller.abort(), 15000);
    try {
      const cart = await Promise.race([
        (async () => {
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { signal: controller.signal });
          if (!response.ok) throw new Error('cart refresh failed');
          return response.json();
        })(),
        cancelled
      ]);
      if (version === cartVersion && !controller.signal.aborted && applyCart(cart)) refreshPending = false;
    } catch (e) {
      // يُحفظ آخر وضع صالح؛ لا وسوم أو حدث شحن من فشل القراءة.
    } finally {
      clearTimeout(request.timer);
      controller.signal.removeEventListener('abort', onAbort);
      if (cartRequest === request) cartRequest = null;
    }
  };

  const queueCartRefresh = () => {
    const version = ++cartVersion;
    refreshPending = true;
    cancelRefresh();
    if (navigator.onLine === false) return;
    refreshTimer = setTimeout(() => {
      refreshTimer = null;
      refreshCart(version);
    }, 50);
  };

  document.addEventListener('cart:change', (event) => {
    ++cartVersion;
    cancelRefresh();
    refreshPending = !applyCart(event.detail?.cart);
  });

  // تطبيق رمز الخصم أو إزالته يطلق cart:refresh بلا السلة؛ تُجمع التحديثات المتقاربة.
  document.addEventListener('cart:refresh', queueCartRefresh);
  window.addEventListener('offline', () => {
    ++cartVersion;
    cancelRefresh();
  });
  window.addEventListener('online', () => { if (refreshPending) queueCartRefresh(); });
  window.addEventListener('pagehide', () => {
    ++cartVersion;
    cancelRefresh();
  });
  window.addEventListener('pageshow', (event) => { if (event.persisted) queueCartRefresh(); });

  // الالتقاط قبل مستمعي الأزرار، فتُقرأ aria-expanded قبل أن تتغير: الفتح وحده يُحسب لا الإغلاق
  document.addEventListener('click', (event) => {
    const tool = event.target.closest?.('.sedr-cart-tool');
    if (!tool || tool.getAttribute('aria-expanded') === 'true') return;
    const panel = tool.getAttribute('aria-controls') || '';
    track('cart_tool_open', { tool: panel.split('-').pop(), place: panel.startsWith('cart-drawer') ? 'drawer' : 'page' });
  }, true);

  // رمز الخصم: Impact يطبّقه عند change في cart-discount-field، ثم يطلق cart:discount:error أو cart:refresh منه
  let discountField = null;
  const discountResult = (result) => (event) => {
    if (!discountField || !discountField.contains(event.target)) return;
    discountField = null;
    // صفحة السلة يُعاد تحميلها بعد تطبيق الرمز مباشرة
    if (result === 'applied' && config.page === 'cart') later('cart_discount_submit', { result });
    else track('cart_discount_submit', { result });
  };
  document.addEventListener('cart:discount:error', discountResult('invalid'));
  document.addEventListener('cart:refresh', discountResult('applied'));

  document.addEventListener('change', (event) => {
    const target = event.target;
    const field = target.closest?.('cart-discount-field');
    if (field && target.value?.trim()) discountField = field;

    if (target.name === 'note' && target.value?.trim()) {
      track('cart_note_save', { place: target.closest('cart-drawer') ? 'drawer' : 'page' });
    }
  });

  /* ------------------------------------------------------------ الوضع */

  document.addEventListener('click', (event) => {
    if (!event.target.closest?.('[data-sedr-scheme-toggle]')) return;
    const before = mode();
    setTimeout(() => {
      const now = mode();
      if (now !== before) track('mode_changed', { to: now });
    });
  }, true);

  /* ------------------------------------------------------------ البحث */

  // صفحة البحث: القيمة من Liquid مشفّرة بصيغة HTML، فتُفك نصًّا
  if (typeof config.noResults === 'string') {
    const terms = new DOMParser().parseFromString(config.noResults, 'text/html').documentElement.textContent;
    track('search_no_results', { q: safeQuery(terms), place: 'page' });
  }

  // البحث الفوري: «لا نتائج» يُحسب إذا بقي النص كما هو ثانيتين، ومرة لكل نص في الصفحة
  const reported = new Set();
  let emptyTimer;
  document.querySelectorAll('predictive-search').forEach((search) => {
    new MutationObserver(() => {
      clearTimeout(emptyTimer);
      if (!search.querySelector(':scope > [slot="results"] .empty-state')) return;
      const input = search.closest('form')?.elements.q;
      const term = input?.value.trim();
      emptyTimer = setTimeout(() => {
        if (!term || input.value.trim() !== term || reported.has(term)) return;
        if (!search.querySelector(':scope > [slot="results"] .empty-state')) return;
        reported.add(term);
        track('search_no_results', { q: safeQuery(term), place: search.closest('search-drawer') ? 'drawer' : 'page' });
      }, 2000);
    }).observe(search, { childList: true });
  });
  document.addEventListener('input', (event) => {
    if (event.target.name === 'q' && event.target.form?.querySelector('predictive-search')) clearTimeout(emptyTimer);
  });

  // النقر على نتيجة ينقل الصفحة، فيُحفظ الحدث للصفحة التالية، إلا إذا فُتحت النتيجة في تبويب آخر
  const opensHere = (event, link) =>
    event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && (!link.target || link.target === '_self');
  const resultClick = (event, link, data) => (opensHere(event, link) ? later : track)('search_result_click', data);

  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('a[href]');
    if (!link) return;

    const panel = link.closest('predictive-search [slot="results"] [slot="content"]');
    if (panel) {
      const position = [...panel.querySelectorAll('a[href]')].indexOf(link) + 1;
      resultClick(event, link, { position, place: link.closest('search-drawer') ? 'drawer' : 'page' });
      return;
    }

    if (config.page !== 'search') return;
    const card = link.closest('.product-list > *, .blog-posts > *');
    if (card) resultClick(event, link, { position: [...card.parentElement.children].indexOf(card) + 1, place: 'page' });
  });

  /* ------------------------------------------------------------ المجموعات */

  // الفلاتر والترتيب والصفحات كلها تمر بـ facet:update في Impact، ومعه الرابط الجديد
  const defaultSort = config.defaultSort || 'relevance';
  let facetParams = new URL(location.href).searchParams;

  document.addEventListener('facet:update', (event) => {
    let next;
    try { next = new URL(event.detail.url).searchParams; } catch (e) { return; }
    const before = facetParams;
    facetParams = next;

    const added = new Set();
    new Set(next.keys()).forEach((key) => {
      if (!key.startsWith('filter.')) return;
      const old = before.getAll(key);
      if (next.getAll(key).some((value) => value && !old.includes(value))) added.add(key.replace(/\.(gte|lte)$/, ''));
    });
    added.forEach((filter) => track('collection_filter_applied', { filter }));

    // نموذج الفلاتر الأفقي ورابط «مسح الكل» لا يحملان sort_by، فلا يُعد غيابه تغييرًا من العميل
    const sort = next.get('sort_by') || defaultSort;
    if (next.has('sort_by') && sort !== (before.get('sort_by') || defaultSort)) track('collection_sort_changed', { sort });

    const page = Number(next.get('page')) || 1;
    if (page > (Number(before.get('page')) || 1)) track('collection_next_page', { page });
  });
})();
